import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ 
  title, 
  description, 
  actions 
}: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 pb-6">
      <div className="flex-1">
        <h2 className="text-2xl font-bold mb-2">{title}</h2>
        {description && (
          <div className="text-muted-foreground">{description}</div>
        )}
      </div>
      
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
